module.exports = __webpack_public_path__ + "img/energyImg3.640d9cfe.png";